/**
 * Tipos da Store de Endereços.
 */
export const ADDRESSES = 'addresses/ADDRESSES'
export const ADDRESS_IMPORT = 'addresses/ADDRESS_IMPORT'
export const ADDRESS_CREATE = 'addresses/ADDRESS_CREATE'
export const ADDRESS_UPDATE = 'addresses/ADDRESS_UPDATE'
export const ADDRESS_EXCLUDE = 'addresses/ADDRESS_EXCLUDE'
export const ADDRESSES_ACTIVE = 'addresses/ADDRESSES_ACTIVE'
export const ADDRESSES_CITIES = 'addresses/ADDRESSES_CITIES'
export const ADDRESSES_STATES = 'addresses/ADDRESSES_STATES'

/**
 * Tipos da Store de Prêmios.
 */
export const AWARD = 'awards/AWARD'
export const AWARDS = 'awards/AWARDS'
export const AWARDS_PAGINATE = 'awards/AWARDS_PAGINATE'
export const AWARDS_CONFIRM = 'awards/AWARDS_CONFIRM'
export const AWARDS_CANCEL = 'awards/AWARDS_CANCEL'
export const AWARD_UPDATE = 'awards/AWARD_UPDATE'

/**
 * Tipos da Store de Pontos.
 */
export const ENGAGEMENT_ORDER = 'engagement/ENGAGEMENT_ORDER'
export const ENGAGEMENT_ORDERS = 'engagement/ENGAGEMENT_ORDERS'
export const ENGAGEMENT_ORDERS_PAGINATE = 'engagement/ENGAGEMENT_ORDERS_PAGINATE'
export const ENGAGEMENT_ORDERS_SCHEDULE = 'engagement/ENGAGEMENT_ORDERS_SCHEDULE'
export const ENGAGEMENT_ORDERS_CANCEL = 'engagement/ENGAGEMENT_ORDERS_CANCEL'
export const ENGAGEMENT_ORDER_UPDATE = 'engagement/ENGAGEMENT_ORDER_UPDATE'

/**
* Tipos da Store de Notificações.
*/
export const NOTIFICATIONS = 'notifications/NOTIFICATIONS'
export const NOTIFICATIONS_INCLUDE = 'notifications/NOTIFICATIONS_INCLUDE'
export const NOTIFICATIONS_EXCLUDE = 'notifications/NOTIFICATIONS_EXCLUDE'

/**
* Tipos da Store de Autenticação.
*/
export const AUTH = 'auth/AUTH'
export const AUTH_TOKEN = 'auth/AUTH_TOKEN'
export const AUTH_LOGIN = 'auth/AUTH_LOGIN'
export const AUTH_LOGOUT = 'auth/AUTH_LOGOUT'

/**
* Tipos da Store do Menu.
*/
export const MENU_OPEN = 'menu/MENU_OPEN'
export const MENU_ITEMS = 'menu/MENU_ITEMS'
export const MENU_CLOSE = 'menu/MENU_CLOSE'

/**
* Tipos da Store de Parceiros.
*/
export const PERKS = 'perks/PERKS'
export const PERKS_CASHBACK = 'perks/PERKS_CASHBACK'
export const TESTE_PERKS = 'perks/TESTE_PERKS'
export const PERKS_EXCLUSIVES = 'perks/PERKS_EXCLUSIVES'
export const PERKS_BLOCKED = 'perks/PERKS_BLOCKED'
export const PERK_ADD_BLOCKS = 'perks/PERK_ADD_BLOCKS'
export const PERK_BLOCK_CATEGORY = 'perks/PERK_BLOCK_CATEGORY'
export const PERKS_PAGINATE = 'perks/PERKS_PAGINATE'
export const PERK_DETAILS = 'perks/PERK_DETAILS'
export const PERK_DETAILS_PATCH = 'perks/PERK_DETAILS_PATCH'
export const PERK_DETAILS_EMPTY = 'perks/PERK_DETAILS_EMPTY'
export const PERK_CREATE = 'perks/PERK_CREATE'
export const PERK_UPDATE = 'perks/PERK_UPDATE'
export const PERK_DELETE = 'perks/PERK_DELETE'
export const PERKS_ENABLE = 'perks/PERKS_ENABLE'
export const PERKS_DISABLE = 'perks/PERKS_DISABLE'
export const PERKS_EXCLUDE = 'perks/PERKS_EXCLUDE'

/**
* Tipos da Store de Parceiros.
*/
export const CAMPAIGNS = 'campaigns/CAMPAIGNS'
export const CAMPAIGNS_CASHBACK = 'campaigns/CAMPAIGNS_CASHBACK'
export const CAMPAIGNS_HIGHLIGHT = 'campaigns/CAMPAIGNS_HIGHLIGHT'
export const CAMPAIGNS_CREATE_HIGHLIGHT = 'campaigns/CAMPAIGNS_CREATE_HIGHLIGHT'
export const CAMPAIGN_DETAILS = 'campaigns/CAMPAIGN_DETAILS'
export const CAMPAIGN_EDIT = 'campaigns/CAMPAIGN_EDIT'
export const CAMPAIGN_DELETE = 'campaigns/CAMPAIGN_DELETE'
export const CAMPAIGNS_ENABLE = 'campaigns/CAMPAIGNS_ENABLE'
export const CAMPAIGNS_DISABLE = 'campaigns/CAMPAIGNS_DISABLE'
export const CAMPAIGNS_DELETE = 'campaigns/CAMPAIGNS_DELETE'
export const CAMPAIGN_ADDRESSES = 'campaigns/CAMPAIGN_ADDRESSES'
export const CAMPAIGN_DETAILS_PATCH = 'campaigns/CAMPAIGN_DETAILS_PATCH'
export const CAMPAIGN_ADDRESSES_ENABLE = 'campaigns/CAMPAIGN_ADDRESSES_ENABLE'
export const CAMPAIGN_ADDRESSES_DISABLE = 'campaigns/CAMPAIGN_ADDRESSES_DISABLE'
export const CAMPAIGN_IMPORT_CODES = 'campaigns/CAMPAIGN_IMPORT_CODES'
export const CAMPAIGNS_PAGINATE = 'campaigns/CAMPAIGNS_PAGINATE'
export const CAMPAIGN_PERK_DETAILS = 'campaign/CAMPAIGN_PERK_DETAILS'

/**
* Tipos da Store de Tags.
*/
export const TAGS = 'tags/TAGS'
export const TAGS_IN_BANNER = 'tags/TAGS_IN_BANNER'
export const TAG_CREATE = 'tags/TAG_CREATE'
export const TAGS_PAGINATE = 'tags/TAGS_PAGINATE'
export const TAGS_ENABLE = 'tags/TAGS_ENABLE'
export const TAGS_DISABLE = 'tags/TAGS_DISABLE'
export const TAGS_EXCLUDE = 'tags/TAGS_EXCLUDE'

/**
* Tipos da Store de Categorias.
*/
export const CATEGORIES = 'categories/CATEGORIES'
export const CATEGORIES_OPTIONS = 'categories/CATEGORIES_OPTIONS'

/**
* Tipos da Store de Clientes.
*/
export const CLIENT = 'clients/CLIENT'
export const CLIENT_CLEAR = 'clients/CLIENT_CLEAR'
export const CLIENT_PATCH = 'clients/CLIENT_PATCH'
export const CLIENT_CREATE = 'clients/CLIENT_CREATE'
export const CLIENT_DELETE = 'clients/CLIENT_DELETE'
export const CLIENTS = 'clients/CLIENTS'
export const CLIENTS_PAGINATE = 'clients/CLIENTS_PAGINATE'
export const CLIENTS_IMPORTS = 'clients/CLIENTS_IMPORTS'
export const VIDALINK_CLIENTS = 'clients/VIDALINK_CLIENTS'

/**
* Tipos da Store de Relatórios.
*/
export const REPORTS = 'reports/REPORTS'
export const REPORTS_LOADING = 'reports/REPORTS_LOADING'
export const REPORTS_DOWNLOAD = 'reports/REPORTS_DOWNLOAD'

/**
* Tipos da Store da Carteira.
*/
export const GET_ORDERS = 'wallet/GET_ORDERS'
export const FETCH_NEW_ORDER = 'wallet/FETCH_NEW_ORDER'
export const WALLET_ORDERS_PAGINATE = 'wallet/WALLET_ORDERS_PAGINATE'

/**
* Tipos da Store de Contas.
*/
export const ACCOUNT = 'accounts/ACCOUNT'
export const ACCOUNTS = 'accounts/ACCOUNTS'
export const ACCOUNT_CLEAR_ID = 'accounts/ACCOUNT_CLEAR_ID'
export const ACCOUNT_CONFIG = 'accounts/ACCOUNT_CONFIG'
export const ACCOUNT_CONFIG_UPDATE = 'accounts/ACCOUNT_CONFIG_UPDATE'
export const ACCOUNT_SEARCH = 'accounts/ACCOUNT_SEARCH'
export const ACCOUNT_DELETE_PERMISSION = 'accounts/ACCOUNT_DELETE_PERMISSION'
export const ACCOUNT_CLEAR = 'accounts/ACCOUNT_CLEAR'
export const ACCOUNT_CREATE = 'account/ACCOUNT_CREATE'
export const ACCOUNT_PATCH = 'account/ACCOUNT_PATCH'
export const ACCOUNT_UPDATE = 'account/ACCOUNT_UPDATE'
export const ACCOUNT_DELETE = 'accounts/ACCOUNT_DELETE'
export const ACCOUNT_VINDI = 'accounts/ACCOUNT_VINDI'
export const ACCOUNT_BLOCKED_PARTNERS = 'accounts/ACCOUNT_BLOCKED_PARTNERS'
export const ACCOUNTS_WITH_EMAIL_PERMISSION = 'accounts/ACCOUNTS_WITH_EMAIL_PERMISSION'
export const CREATE_WALLET_ORDER = 'accounts/CREATE_WALLET_ORDER'
export const CREATE_WALLET_EXIT_ORDER = 'accounts/CREATE_WALLET_EXIT_ORDER'
export const VIDALINK_ACCOUNTS = 'accounts/VIDALINK_ACCOUNTS'

/**
* Tipos da Store de Parceiros Bloqueados.
*/
export const ACCOUNT_BLOCKED_PARTNERS_ = 'accounts/ACCOUNT_BLOCKED_PARTNERS_'
export const ACCOUNT_BLOCKED_PARTNERS_PAGINATE = 'accounts/ACCOUNT_BLOCKED_PARTNERS_PAGINATE'
export const ACCOUNT_BLOCKED_PARTNERS_ENABLE = 'accounts/ACCOUNT_BLOCKED_PARTNERS_ENABLE'
export const ACCOUNT_BLOCKED_PARTNERS_DISABLE = 'accounts/ACCOUNT_BLOCKED_PARTNERS_DISABLE'

/**
* Tipos da Store de Usuários.
*/
export const USERS = 'users/USERS'
export const USER_CASHBACK = 'users/USER_CASHBACK'
export const USER = 'users/USER'
export const USER_CLEAR = 'users/USER_CLEAR'
export const USERS_PAGINATE = 'users/USERS_PAGINATE'
export const USER_EDIT = 'users/USER_EDIT'
export const USERS_BATCH = 'users/USERS_BATCH'
export const USER_VERIFY = 'users/USER_VERIFY'
export const USERS_QUERY = 'users/USERS_QUERY'
export const USERS_PARAMS = 'users/USERS_PARAMS'

/**
* Tipos da Store de Resgates.
*/
export const RESCUES = 'rescues/RESCUES'
export const RESCUES_PAGINATE = 'rescues/RESCUES_PAGINATE'
export const RESCUES_QUERY = 'rescues/RESCUES_QUERY'
export const RESCUES_PARAMS = 'rescues/RESCUES_PARAMS'

/**
 * Tipos da Store de Transações.
 */
export const TRANSACTIONS = 'transactions/TRANSACTIONS'
export const TRANSACTIONS_PAGINATE = 'transactions/TRANSACTIONS_PAGINATE'
export const TRANSACTIONS_QUERY = 'transactions/TRANSACTIONS_QUERY'
export const TRANSACTIONS_PARAMS = 'transactions/TRANSACTIONS_PARAMS'
export const TRANSACTIONS_UPDATE = 'transactions/TRANSACTIONS_UPDATE'

/**
 * Tipos da Store de Resumo de cashback.
 */
export const CASHBACK = 'cashback/CASHBACK'
export const CASHBACK_SUMMARY = 'cashback/CASHBACK_SUMMARY'
export const CASHBACK_SUMMARY_PAGINATE = 'cashback/CASHBACK_SUMMARY_PAGINATE'
export const CASHBACK_SUMMARY_QUERY = 'cashback/CASHBACK_SUMMARY_QUERY'
export const CASHBACK_SUMMARY_PARAMS = 'cashback/CASHBACK_SUMMARY_PARAMS'

export const CASHBACK_CREATE = 'cashback/CASHBACK_CREATE'
export const CASHBACK_RESCUE = 'cashback/CASHBACK_RESCUE'
export const CASHBACK_RESCUE_PAGINATE = 'cashback/CASHBACK_RESCUE_PAGINATE'
export const CASHBACK_RESCUE_QUERY = 'cashback/CASHBACK_RESCUE_QUERY'
export const CASHBACK_RESCUE_PARAMS = 'cashback/CASHBACK_RESCUE_PARAMS'
export const CASHBACK_RESCUES_UPDATE = 'cashback/CASHBACK_RESCUES_UPDATE'

/**
 * Tipos da Store de Resumo de Saques
 */
export const WITHDRAWS = 'withdraws/WITHDRAWS'
export const WITHDRAWS_PAGINATE = 'withdraws/WITHDRAWS_PAGINATE'
export const WITHDRAW_UPDATE = 'withdraws/WITHDRAW_UPDATE'

/**
* Tipos da Store de Resumo de chargebacks.
*/
export const CHARGEBACKS = 'chargebacks/CHARGEBACKS'
export const CHARGEBACKS_PAGINATE = 'chargebacks/CHARGEBACKS_PAGINATE'
export const GET_CHARGEBACKS = 'chargebacks/GET_CHARGEBACKS'
export const IMPORT_CHARGEBACKS = 'chargebacks/IMPORT_CHARGEBACKS'
export const UPDATE_CHARGEBACK = 'chargebacks/UPDATE_CHARGEBACK'

/**
* Tipos da Store de Mídias.
*/
export const MEDIAS = 'medias/MEDIAS'
export const MEDIA = 'medias/MEDIA'
export const MEDIAS_PAGINATE = 'medias/MEDIAS_PAGINATE'
export const MEDIA_EDIT = 'medias/MEDIA_EDIT'
export const MEDIAS_ENABLE = 'medias/MEDIAS_ENABLE'
export const MEDIAS_DISABLE = 'medias/MEDIAS_DISABLE'
export const MEDIAS_EXCLUDE = 'medias/MEDIAS_EXCLUDE'
export const MEDIA_IMAGE_UPLOAD = 'medias/MEDIA_IMAGE'

/**
* Tipos da Store de Banners.
*/

export const BANNERS = 'banners/BANNERS'
export const BANNER = 'banners/BANNER'
export const BANNERS_PAGINATE = 'banners/BANNERS_PAGINATE'
export const BANNER_EDIT = 'banners/BANNER_EDIT'
export const BANNERS_ENABLE = 'banners/BANNERS_ENABLE'
export const BANNERS_DISABLE = 'banners/BANNERS_DISABLE'
export const BANNERS_EXCLUDE = 'banners/BANNERS_EXCLUDE'
export const BANNER_IMAGE_UPLOAD = 'banners/BANNER_IMAGE'

/**
* Tipos da Store de Pop-ups
*/
export const CREATE_POPUP = 'popups/CREATE_POPUP'
export const POPUP = 'popups/POPUP'
export const POPUPS = 'popups/POPUPS'
export const POPUPS_PAGINATE = 'popups/POPUPS_PAGINATE'

/**
* Tipos da Store de Notifications
*/
export const CREATE_NOTICE = 'notice/CREATE_NOTICE'
export const NOTICE = 'notice/NOTICE'
export const NOTICES = 'notice/NOTICES'
export const NOTICES_PAGINATE = 'notice/NOTICES_PAGINATE'
export const NOTICES_ENABLE = 'notice/NOTICES_ENABLE'
export const NOTICES_DISABLE = 'notice/NOTICES_DISABLE'

/**
* Tipos da Store de Permissões
*/
export const PERMISSIONS = 'permissions/PERMISSIONS'

/**
* Bandeiras de cartão de credito
*/
export const BRANDS = 'brands/BRANDS'

/**
* Tipos da Store de Roles
*/
export const ROLE_ADD = 'roles/ROLE_ADD'
export const ROLE_DELETE = 'roles/ROLE_DELETE'

/**
* Tipos da Store Common
*/
export const SEND_NOTIFICATION_BY_EMAIL = 'common/SEND_NOTIFICATION_BY_EMAIL'

/**
* Tipos da Store de Busca
*/
const SEARCH = 'search/SEARCH'
const SEARCH_PAGES = 'search/SEARCH_PAGES'
const SEARCH_RESULTS_COUNT = 'search/SEARCH_RESULTS_COUNT'
const SEARCH_MORE = 'search/SEARCH_MORE'
const SEARCH_LESS = 'search/SEARCH_LESS'
const SEARCH_QUERY = 'search/SEARCH_QUERY'
const SEARCH_RESET_PAGES = 'search/SEARCH_RESET_PAGES'
const SEARCH_MORE_ALLOWED = 'search/SEARCH_MORE_ALLOWED'
const SEARCH_LESS_ALLOWED = 'search/SEARCH_LESS_ALLOWED'

/**
 * Tipos da Store do Epay
*/

const EPAY_PRODUCTS = 'epay/EPAY_PRODUCTS'
const EPAY_CREATE = 'epay/EPAY_CREATE'

const TODO_BRANDS = 'todo/TODO_BRANDS'
const TODO_CREATE = 'todo/TODO_CREATE'

const GIFTTY_PRODUCTS = 'giftty/GIFTTY_PRODUCTS'
/**
 * Tipos da Store do Epay
*/
const GET_COMMUNICATION_EMAILS = 'communication/GET_COMMUNICATION_EMAILS'
const COMMUNICATION_EMAIL = 'communication/COMMUNICATION_EMAIL'
const NEW_COMMUNICATION_EMAIL = 'communications/NEW_COMMUNICATION_EMAIL'
const EDIT_COMMUNICATION_EMAIL_STATUS = 'communications/EDIT_COMMUNICATION_EMAIL_STATUS'
const EMAILS_PAGINATE = 'communications/EMAILS_PAGINATE'

const VOUCHERS = 'vouchers/VOUCHERS'
const VOUCHERS_PAGINATE = 'vouchers/VOUCHERS_PAGINATE'

const GET_LESSONS = 'academy/GET_LESSONS'
const GET_LESSON = 'academy/GET_LESSON'
const LESSONS_PAGINATE = 'academy/LESSONS_PAGINATE'
const CREATE_LESSON = 'academy/CREATE_LESSON'
const UPDATE_LESSON = 'academy/UPDATE_LESSON'
const LESSON_STATUS = 'academy/LESSON_STATUS'
const DELETE_LESSON = 'academy/DELETE_LESSON'

const GET_UNITS = 'academy/GET_UNITS'
const UNITS_PAGINATE = 'academy/UNITS_PAGINATE'
const CREATE_UNIT = 'academy/CREATE_UNIT'
const UPDATE_UNIT = 'academy/UPDATE_UNIT'
const UNIT_STATUS = 'academy/UNIT_STATUS'
const DELETE_UNIT = 'academy/DELETE_UNIT'

const GET_SUBJECTS = 'academy/GET_SUBJECTS'
const SUBJECTS_PAGINATE = 'academy/SUBJECTS_PAGINATE'
const CREATE_SUBJECT = 'academy/CREATE_SUBJECT'
const UPDATE_SUBJECT = 'academy/UPDATE_SUBJECT'
const SUBJECT_STATUS = 'academy/SUBJECT_STATUS'
const DELETE_SUBJECT = 'academy/DELETE_SUBJECT'

const GET_ARTICLES = 'academy/GET_ARTICLES'
const GET_ARTICLE = 'academy/GET_ARTICLE'
const ARTICLES_PAGINATE = 'academy/ARTICLES_PAGINATE'
const CREATE_ARTICLE = 'academy/CREATE_ARTICLE'
const UPDATE_ARTICLE = 'academy/UPDATE_ARTICLE'
const ARTICLE_STATUS = 'academy/ARTICLE_STATUS'
const DELETE_ARTICLE = 'academy/DELETE_ARTICLE'
export {
  SEARCH, SEARCH_PAGES, SEARCH_RESULTS_COUNT,
  SEARCH_MORE, SEARCH_LESS, SEARCH_QUERY, SEARCH_RESET_PAGES,
  SEARCH_MORE_ALLOWED, SEARCH_LESS_ALLOWED, EPAY_PRODUCTS, EPAY_CREATE, TODO_BRANDS, TODO_CREATE,
  GET_COMMUNICATION_EMAILS, COMMUNICATION_EMAIL, NEW_COMMUNICATION_EMAIL, EDIT_COMMUNICATION_EMAIL_STATUS, EMAILS_PAGINATE,
  GIFTTY_PRODUCTS, VOUCHERS, VOUCHERS_PAGINATE,
  GET_LESSONS, GET_LESSON, LESSONS_PAGINATE, CREATE_LESSON, UPDATE_LESSON, LESSON_STATUS, DELETE_LESSON,
  GET_UNITS, UNITS_PAGINATE, CREATE_UNIT, UPDATE_UNIT, UNIT_STATUS, DELETE_UNIT,
  GET_SUBJECTS, SUBJECTS_PAGINATE, CREATE_SUBJECT, UPDATE_SUBJECT, SUBJECT_STATUS, DELETE_SUBJECT,
  GET_ARTICLES, GET_ARTICLE, ARTICLES_PAGINATE, CREATE_ARTICLE, UPDATE_ARTICLE, ARTICLE_STATUS, DELETE_ARTICLE
}



// WEBPACK FOOTER //
// ./src/store/types.js